import { gettext } from '@eventbrite/i18n';
import {
    trackGetDataError,
    trackGetDataSuccess,
    trackModalClose,
    trackModalOpen,
    trackRatingHelperCenterClick,
    trackRatingsDisplayed,
    trackRatingsLoaded,
    trackRatingsNotDisplayed,
} from '../tracking/analytics';
import {
    logGetDataError,
    logGetDataSuccess,
    logModalClose,
    logModalOpen,
    logRatingHelperCenterClick,
    logRatingsDisplayed,
    logRatingsLoaded,
    logRatingsNotDisplayed,
} from '../tracking/statsig';
export const MOCK_ORGANIZER = '123';

export const mockedGetRatingSample = {
    rating: 2.9,
    total_count: {
        value: 1456,
        display: '1.45K',
    },
    break_down: [
        {
            rating_star: 5,
            count: 100,
            display: '100',
            percentage: 0.07,
        },
        {
            rating_star: 4,
            count: 300,
            display: '300',
            percentage: 0.21,
        },
        {
            rating_star: 3,
            count: 700,
            display: '700',
            percentage: 0.48,
        },
        {
            rating_star: 2,
            count: 0,
            display: '0',
            percentage: 0,
        },
        {
            rating_star: 1,
            count: 356,
            display: '356',
            percentage: 0.24,
        },
    ],
    tag_summary: [
        {
            id: '1',
            display_text: 'Meet people',
            count: 20,
        },
        {
            id: '12',
            display_text: 'Professionals',
            count: 7,
        },
    ],
};

export const GET_RATING_URL = '/api/v3/reviews/organizer_rating/';
export const ERROR_OTHER = gettext('There is an error. Try again later.');
export const SUPPORT_BASE_URL = 'https://www.eventbrite.com/support';
export const HELP_CENTER_ATTENDEE_URL = `${SUPPORT_BASE_URL}/articleredirect?anum=41782`;
export const HELP_CENTER_ORGANIZER_URL = `${SUPPORT_BASE_URL}/articleredirect?anum=41786`;

export const TRACK_EVENTS_PLATFORMS = ['GA', 'StatSig'];

export const GET_RATING_OBJECT_TRACKING_METHODS = {
    GA: {
        RATINGS_LOADED: (trackCategory: string, organizerId: string) =>
            trackRatingsLoaded(trackCategory, organizerId),
    },
    StatSig: {
        RATINGS_LOADED: (trackCategory: string, organizerId: string) =>
            logRatingsLoaded(trackCategory, organizerId),
    },
};

export const RATING_DISPLAY_TRACKING_METHODS = {
    GA: {
        RATING_NOT_DISPLAYED: (
            trackCategory: string,
            rating: number,
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            organizerId: string,
        ) => trackRatingsNotDisplayed(trackCategory, rating || 0),
        RATING_DISPLAYED: (
            trackCategory: string,
            rating: number,
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            organizerId: string,
        ) => trackRatingsDisplayed(trackCategory, rating || 0),
        MODAL_OPEN: (trackCategory: string, organizerId: string) =>
            trackModalOpen(trackCategory, organizerId),
        MODAL_CLOSE: (trackCategory: string, organizerId: string) =>
            trackModalClose(trackCategory, organizerId),
    },
    StatSig: {
        RATING_NOT_DISPLAYED: (
            trackCategory: string,
            rating: number,
            organizerId: string,
        ) => logRatingsNotDisplayed(trackCategory, rating || 0, organizerId),
        RATING_DISPLAYED: (
            trackCategory: string,
            rating: number,
            organizerId: string,
        ) => logRatingsDisplayed(trackCategory, rating || 0, organizerId),
        MODAL_OPEN: (trackCategory: string, organizerId: string) =>
            logModalOpen(trackCategory, organizerId),
        MODAL_CLOSE: (trackCategory: string, organizerId: string) =>
            logModalClose(trackCategory, organizerId),
    },
};

export const RATING_DETAIL_MODAL_TRACKING_METHODS = {
    GA: {
        HELPER_CENTER_CLICK: (trackCategory: string, organizerId: string) =>
            trackRatingHelperCenterClick(trackCategory, organizerId),
    },
    StatSig: {
        HELPER_CENTER_CLICK: (
            trackCategory: string,
            organizerId: string,
            link: string,
        ) => logRatingHelperCenterClick(trackCategory, organizerId, link),
    },
};

export const GET_RATING_DATA_TRACKING_METHODS = {
    GA: {
        GET_DATA_SUCCESS: (trackCategory: string, organizerId: string) =>
            trackGetDataSuccess(trackCategory, organizerId),
        GET_DATA_ERROR: (
            trackCategory: string,
            organizerId: string,
            error: string,
        ) => trackGetDataError(trackCategory, organizerId, error),
    },
    StatSig: {
        GET_DATA_SUCCESS: (trackCategory: string, organizerId: string) =>
            logGetDataSuccess(trackCategory, organizerId),
        GET_DATA_ERROR: (
            trackCategory: string,
            organizerId: string,
            error: string,
        ) => logGetDataError(trackCategory, organizerId, error),
    },
};
